import { render, staticRenderFns } from "./PlantCard.vue?vue&type=template&id=bceeb584"
import script from "./PlantCard.vue?vue&type=script&lang=js"
export * from "./PlantCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports